<script>
    let {
        label = '',
        value = $bindable(),
        placeholder = 'Select an option...',
        name = '',
        rows = 5,
        class: cls = ''
    } = $props();
</script>

<label class="tw:block tw:text-sm tw:font-medium tw:text-gray-900 tw:relative tw:w-full {cls}">
    <span class="">{label}</span>
    <textarea {name} bind:value={value} {rows}
           class="tw:bg-gray-50 tw:border tw:border-gray-300 tw:text-gray-900 tw:text-sm tw:rounded-lg tw:focus:ring-blue-500 tw:focus:border-blue-500 tw:block tw:w-full tw:p-2.5"
           {placeholder}
    ></textarea>
</label>